import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Accordion = (props) => {
  const { title, description, children, initialValue = true, classContainer } = props;
  const [isOpen, setIsOpen] = useState(initialValue);

  return (
    <details className={`bg-white rounded-2xl ${classContainer}`} open={isOpen} onToggle={(e) => setIsOpen(e.target.open)}>
      <summary className="flex justify-between cursor-pointer p-4 list-none marker:hidden items-center">
        <div className="flex flex-col">
          <span className={'text-lg'}>{title}</span>
          <span className={'text-sm text-gray-500'}>{description}</span>
        </div>
        <KeyboardArrowDownIcon className={`text-gray-500 ${isOpen ? 'rotate-180' : ''}`} />
      </summary>

      <div>{children}</div>
    </details>
  );
};
export default Accordion;
